var _g, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetricIconPoll(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16857_2634)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.00390625,
    y: -0.00390625,
    width: 32,
    height: 32,
    rx: 5.81818,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.746094,
    y: 0.746094,
    width: 30.5,
    height: 30.5,
    rx: 5.06818,
    stroke: "#C728FF",
    strokeOpacity: 0.1,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_16857_2634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.49609 23.4961V16.7461H12.9961",
    stroke: "#C728FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9961 23.4961H6.99609",
    stroke: "#C728FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9961 23.4961V12.2461H18.2461",
    stroke: "#C728FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2461 23.4961V7.74609H23.4961V23.4961",
    stroke: "#C728FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.65234 8.87109H12.1523",
    stroke: "#C728FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.90234 6.62109V11.1211",
    stroke: "#C728FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.296094,
    y: 0.296094,
    width: 31.4,
    height: 31.4,
    rx: 4.7,
    stroke: "#C728FF",
    strokeWidth: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16857_2634"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.00390625,
    y: -0.00390625,
    width: 32,
    height: 32,
    rx: 5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_16857_2634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(3.99609 3.99609)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricIconPoll);
export default __webpack_public_path__ + "static/media/MetricIconPoll.c645146e8561e41ceb6853f326cc3b25.svg";
export { ForwardRef as ReactComponent };